module.exports = __webpack_public_path__ + "img/markets-dragon-capital.447ad325.jpg";